/* eslint no-cond-assign: 1 */
import * as axios from "axios";
import { util } from './util.js';
import { Performance } from './Performance.js';
import { BOM } from './BOM.js';
var _env = util.getEnv();
//
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;

var _urlString=util.getUrlStrs();

function _format(param) {
    if (typeof param == "undefined") {
        return "";
    }
    if (typeof param != "object") {
        throw new Error("data sended to the server must be 'object'");
    }
    var s = [];
    for (var j in param) {
        s.push(encodeURIComponent(j) + "=" + encodeURIComponent(param[j]));
    }
    var result = s.join("&")
        .replace(/%20/g, "+");
    return result === "" ? result : "&" + result;
}
var unique_device_id=util.getCookie('UM_distinctid');
var _parameters = (function () {
    var params=_urlString;
    !params.appid&&(params.appid="com.dokidokilive.web.Live");
    !params.phonetype&&(params.phonetype="web");
    !params.unique_device_id&&unique_device_id!=""&&(params.unique_device_id=unique_device_id);
    return params;
})();
//存储每个请求允许请求次数的信息
var _request_store = {};

//网络错误处理
function _networkerror_function(key, options, error, e,url) {
    var _cache = _request_store[key];
    if (_cache.count != 0) {
        _cache.count--;
        options.key = key;
        //10秒钟后重试
        setTimeout(function () {
            _request(options);
        }, 10000);
    } else {
        _request_store[key] = null;
        error(2, e);//2 network error
        //上报日志
        _log({
            url:url,
            e:e
        });
    }
}
//
function _log(data) {
    data&&(data.type="error");
    Performance.log(data)
};
//
function _request(options) {

    if (!options.url) {
        throw ("url required");
    }
    //
    var _options = {
        method: "get",
        crossOrigin: true,
        hybrid: true,
        json: false,
        baseUrl: "https://api.dokidokilive.com",
        env: _env || "dev",
        callback: function () {
        },
        error: function (status, e) {
            //处理非业务的异常1 abort  2 网络错误  3 业务 d d
            if (status === 1) {
                //alert("request time out")
                //console.log("request time out");
            } else if (status === 2) {
                //alert("network error")
                //console.log(e);
            } else if (status === 3) {
                //alert("callback error")
                //console.log(e);
            }
            BOM.window.alert(e);
        },
        data: {}
    };
    //参数复制
    for (var o in options) {
        _options[o] = options[o];
    }
    //请求端唯一标示
    var _key = _options.key || (new Date().getTime()
        .toString() + (Math.ceil(Math.random() * 1000)).toString());

    //初始化，每个请求额外三次机会
    !_options.key && (_request_store[_key] = { count: 3 });

    //添加key参数
    _options.url = (_options.url.indexOf("?") === -1 ? _options.url + "?req_id=" + _key : _options.url + "&req_id=" + _key);

    //判断是不是重试请求，如果是，将参数添加到参数上
    _options.retry && (_options.url = _options.url + "&retry=1");

    var _extraUrlString=_options.method.toLowerCase()==="post"?util.getUrlStrs(_options.url):_options.data;
    var _o={};
    //去除重复通用参数
    for(var o in _parameters){
        if(!_extraUrlString[o]){
            _o[o]=_parameters[o];
        }
    }
    _options.url=_options.url+"&"+util.format(_o);

    //_options.url = _options.url + _parameters;

    if (_options.hybrid) {
        if (_options.env != "cdn") {
            _options.url = "/webdoki" + _options.url;
        }
    } else {
        if (_options.env === "cdn" && _options.crossOrigin) {
            _options.url = _options.baseUrl + _options.url;
        }
    }
    //发起请求
    if (_options.method.toLowerCase() === "post") {
        var _postOption = {
            method: 'post',
            url: _options.url,
            data: _options.data
        };
        if (!_options.json) {
            _postOption.transformRequest = [
                function (data) {
                    // 对 data 进行任意转换处理
                    return _format(data);
                }
            ];
            _postOption.headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
        }
        return axios(_postOption)
            .then(function (response) {
                try{
                    _options.callback(response.data);
                }catch (e) {
                    _options.error(3,e);
                    _log({
                        url:_options.url,
                        e:e
                    })
                }
            })
            .catch(function (e) {
                if (e.response) {
                    _options.error(3,e);
                    _log({
                        url:_options.url,
                        e:e
                    })
                } else {
                    //newwork error
                    _networkerror_function(_key, options, _options.error, e,_options.url);
                }
            });
    } else {
        return axios.get(_options.url + _format(_options.data))
            .then(function (response) {
                try {
                    _options.callback(response.data);
                } catch (e) {
                    _options.error(3, e);
                    _log({
                        url:_options.url,
                        e:e
                    })
                }
            })
            .catch(function (e) {
                if (e.response) {
                    _options.error(3,e);
                    _log({
                        url:_options.url,
                        e:e
                    })
                } else {
                    //newwork error
                    _networkerror_function(_key, options, _options.error, e,_options.url);
                }
            });
    }
}

var request = _request;
export {
    request
};